import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        getPackageData(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/packages/v1/getData`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addPackageData(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/packages/v1/addData`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updatePackageData(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/packages/v1/updateData/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                .post('/packages/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deletePackageData(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/packages/v1/deleteData/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}